// Four at-a-glance tiles under the sheet title. Counts already respect the
// agent filter (they're derived from the filtered section data).
export default function SummaryStrip({ pending, listings, appointments, aBuyers }) {
  const tiles = [
    { label: "Pending Deals", value: pending },
    { label: "Active Listings", value: listings },
    { label: "Appointments", value: appointments },
    { label: "A Buyers", value: aBuyers },
  ];
  return (
    <div className="grid grid-cols-2 sm:grid-cols-4 gap-2 mb-5">
      {tiles.map((t) => (
        <div key={t.label} className="bg-slate-50 border border-slate-200 rounded-lg px-3 py-2">
          <div className="text-[11px] text-slate-500">{t.label}</div>
          <div className="text-lg font-semibold text-slate-900">{t.value}</div>
        </div>
      ))}
    </div>
  );
}
